import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Cookies from 'js-cookie';

import {
  setConnected,
  setSocketAuthenticated,
} from '../../shared/components/SocketTester/ducks/feedSocketActions';
import {
  setIncomingFeedPost,
  setIncomingFeedPostComment,
  setIncomingFeedPostCommentReply,
  setIsTyping,
} from './ducks/feedActions';
import feedSocket from '../../shared/utils/setFeedSocketConfig';
import { submitRefreshToken } from '../login/ducks/loginActions';

const SocketHandler = () => {
  const isConnected = useSelector(
    (state) => state.socketTester.feedUi.isConnected,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isConnected) {
      // Check if socket is already connected
      if (feedSocket.connected) {
        dispatch(setConnected(true));
        return;
      }

      // Set up connect event listener
      feedSocket.on('connect', () => {
        dispatch(setConnected(true));
      });

      // Check for access token
      if (Cookies.get('accessToken')) {
        feedSocket.connect();
        feedSocket.emit('authentication', {
          token: Cookies.get('accessToken'),
        });
      } else {
        dispatch(submitRefreshToken()).then((token) => {
          feedSocket.connect();
          feedSocket.emit('authentication', { token });
        });
      }
    }
  }, [isConnected, dispatch]);

  /*
  Define all feedSocket message handlers in a useEffect that gets run only once,
  in order to prevent duplicate messages
  */
  useEffect(() => {
    feedSocket.on('feedPost', (data) => {
      dispatch(setIncomingFeedPost(data));
    });

    feedSocket.on('feedPostComment', (data) => {
      dispatch(setIncomingFeedPostComment(data));
    });

    feedSocket.on('feedPostCommentReply', (data) => {
      dispatch(setIncomingFeedPostCommentReply(data));
    });

    feedSocket.on('authenticated', () => {
      dispatch(setSocketAuthenticated(true));
    });

    feedSocket.on('isTyping', (data) => {
      dispatch(setIsTyping(data));
    });

    feedSocket.on('disconnect', () => {
      dispatch(setConnected(false));
      dispatch(setSocketAuthenticated(false));
    });

    // Add error handlers
    feedSocket.on('connect_error', () => {
      // Handle connection errors silently or log to monitoring service
    });

    feedSocket.on('error', () => {
      // Handle socket errors silently or log to monitoring service
    });

    return () => {
      feedSocket.off('feedPost');
      feedSocket.off('feedPostComment');
      feedSocket.off('feedPostCommentReply');
      feedSocket.off('authenticated');
      feedSocket.off('newWorkoutEntry');
      feedSocket.off('isTyping');
      feedSocket.off('disconnect');
      feedSocket.off('connect_error');
      feedSocket.off('error');
    };
  }, []);

  // Component is just a wrapper to provide socket functionality for Feed. Nothing rendered.
  return null;
};

export default SocketHandler;
